export default [
  {
    path: '/profile',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
    props: (route) => ({ ...route.params }),
    meta: {
      noContextRequired: true
    },
    children: [
      {
        path: '',
        name: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/components/Profile/Detail/ProfileDetail.vue')
      }
    ]
  }
]
